import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_volley-club/artifacts/dg49xs0l_Black%20Decorative%20Shield%20Volleyball%20Club%20Logo%20%28Sweatshirts%29%20%28T-Shirts%29.png";

export default function PendingApprovalPage({ user, onLogout }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-100 via-white to-blue-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={LOGO_URL} alt="NLV Logo" className="w-32 h-32 object-contain" />
          </div>

          {/* Icon */}
          <div className="inline-block p-4 bg-yellow-100 rounded-full mb-6">
            <div className="text-5xl">⏳</div>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-4">Account Pending Approval</h1>
          
          <p className="text-gray-600 text-lg mb-6">
            Hi {user.first_name},<br/><br/>
            Your account has been created successfully and is currently pending admin approval.
            <br/><br/>
            You'll receive an email notification once your account is approved.
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800">
              This usually takes 24-48 hours. Thank you for your patience!
            </p>
          </div>

          <Button
            data-testid="logout-btn"
            onClick={onLogout}
            className="w-full bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-semibold py-6 text-lg rounded-full"
          >
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
